module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/postcode.js
// module id = 840
// module chunks = 0